// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sKs_","label":"styles_label__3L3VI"};